import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface DocumentStatusBadgeProps {
  status?: string | number;
  className?: string;
}

export function DocumentStatusBadge({
  status,
  className
}: DocumentStatusBadgeProps) {
  const { t } = useTranslation();

  const getStatusConfig = (status?: number | string) => {
    const normalizedStatus = status?.toString();

    switch (normalizedStatus) {
      case "approved":
        return {
          label: t("common:documents.status_approved"),
          variant: "default" as const,
          className: "bg-green-600 hover:bg-green-700 text-white"
        };
      case "in_review":
        return {
          label: t("common:documents.status_in_review"),
          variant: "secondary" as const,
          className: "bg-yellow-500 hover:bg-yellow-600 text-white"
        };
      case "declined":
        return {
          label: t("common:documents.status_declined"),
          variant: "destructive" as const,
          className: ""
        };
      case "missing":
        return {
          label: t("common:documents.status_missing", "Fehlt"),
          variant: "outline" as const,
          className: "bg-orange-50 text-orange-700 border-orange-200"
        };
      default:
        return {
          label: t("common:documents.status_in_review"),
          variant: "secondary" as const,
          className: "bg-yellow-500 hover:bg-yellow-600 text-white"
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge variant={config.variant} className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
